import { Container } from 'components/container/Container';

import s from './VideoEmbed.module.scss';

type Props = {
  children: React.ReactNode;
  width?: number;
  height?: number;
};

export const VideoEmbed = ({ children, width, height }: Props) => {
  const style = {
    '--video-width': width,
    '--video-height': height,
  } as React.CSSProperties;

  return (
    <Container>
      <div className={s.videoEmbed} style={style}>
        <div className={s.videoEmbed__frame}>{children}</div>
      </div>
    </Container>
  );
};
